
export default (urlParameters) => {
  return {
    points_of_interest: true
  }
}